import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[cpFocusIndex]'
})
export class FocusIndexDirective implements OnChanges {
  @Input()
  cpFocusIndex: number;

  @Input()
  currentIndex: number;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges() {
    if (this.elementRef && this.cpFocusIndex != null && this.cpFocusIndex === this.currentIndex) {
      const target = this.elementRef.nativeElement as HTMLElement;
      const parent = target.parentElement;

      if (!parent) {
        return;
      }

      if (target.offsetTop < parent.scrollTop) {
        parent.scrollTop -= (parent.scrollTop - target.offsetTop);
      } else if ((target.offsetTop + target.scrollHeight) > (parent.scrollTop + parent.clientHeight)) {
        parent.scrollTop += (target.offsetTop + target.scrollHeight) - (parent.scrollTop + parent.clientHeight);
      }
    }
  }
}

